import { h } from 'preact';
import { useState } from 'preact/hooks';
import { TextCheckboxList } from './TextCheckboxList';
import { ColorSwatch } from './ColorSwatch';
import { RangeSlider } from './RangeSlider';
import styles from './Filter.module.scss';
const ChevronDown = () => (h("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    h("path", { d: "M10.0004 12.2308C9.90003 12.2308 9.80656 12.2148 9.72003 12.1827C9.63351 12.1506 9.55121 12.0956 9.47316 12.0177L5.72795 8.27251C5.61267 8.15709 5.55364 8.01202 5.55087 7.8373C5.54823 7.66272 5.60725 7.51501 5.72795 7.39418C5.84878 7.27348 5.99517 7.21313 6.16712 7.21313C6.33906 7.21313 6.48545 7.27348 6.60628 7.39418L10.0004 10.7886L13.3946 7.39418C13.51 7.2789 13.6551 7.21987 13.8298 7.21709C14.0044 7.21445 14.1521 7.27348 14.273 7.39418C14.3936 7.51501 14.454 7.6614 14.454 7.83334C14.454 8.00529 14.3936 8.15168 14.273 8.27251L10.5277 12.0177C10.4497 12.0956 10.3674 12.1506 10.2809 12.1827C10.1943 12.2148 10.1009 12.2308 10.0004 12.2308Z", fill: "black" })));
export function Filter({ filter, onFilterChange, layout, isOpenByDefault = true }) {
    const [isOpen, setIsOpen] = useState(isOpenByDefault);
    // For filterTop layout with text/select type, render as inline select dropdown
    if (layout === 'filterTop' && (filter.type === 'text' || filter.type === 'select')) {
        return (h("div", { class: "plp-select-wrapper" },
            h("select", { class: "plp-select", onChange: (e) => onFilterChange(filter.id, e.currentTarget.value) },
                h("option", { value: "" }, filter.label),
                (filter.options || []).map(opt => (h("option", { key: opt.id, value: opt.id, selected: opt.selected }, opt.label)))),
            h("span", { class: "plp-select-chevron" },
                h(ChevronDown, null))));
    }
    const renderFilter = () => {
        switch (filter.type) {
            case 'text':
            case 'select':
                return (h(TextCheckboxList, { layout: layout, options: filter.options || [], onChange: (value) => onFilterChange(filter.id, value) }));
            case 'color':
                return (h(ColorSwatch, { options: filter.options || [], onChange: (value) => onFilterChange(filter.id, value) }));
            case 'range':
                return (h(RangeSlider, { min: filter.min || 0, max: filter.max || 1000, gap: filter.gap || 1, currentMin: filter.currentMin || 0, currentMax: filter.currentMax || 1000, onChange: (value) => onFilterChange(filter.id, value.toString()) }));
            default:
                return null;
        }
    };
    return (h("div", { class: styles.filterSection },
        h("button", { class: styles.filterHeader, type: "button", onClick: () => setIsOpen(!isOpen) },
            h("span", { class: styles.filterTitle }, filter.label),
            h("span", { class: `${styles.chevron} ${isOpen ? styles.chevronOpen : ''}` },
                h(ChevronDown, null))),
        isOpen && (h("div", { class: styles.filterBody }, renderFilter()))));
}
